<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12">
		<app-home-head></app-home-head>
	</div>

	<div class="mdc-layout-grid__cell--span-12" id="categories">
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12" id="n47">
				<h6>{{ locale.translations['home']['categories']['n47'] }}</h6>
			</div>
		</div>
	</div>
	<!-- categories -->
	<div class="mdc-layout-grid__cell--span-12" id="categories" *ngIf="categories && categories.length > 0">
		<div class="mdc-layout-grid__inner">
			<div
				class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
				*ngFor="let category of categories"
			>
				<a mat-button [routerLink]="['/c/' + category['id']]" [ngClass]="{ 'align-start': viewport.type !== 'desktop' }">
					<mat-icon class="mat-icon-rtl-mirror">{{ category['webIcon'] }}</mat-icon>

					<span>{{ category['name'] }}</span>
				</a>
			</div>
		</div>
	</div>

	<!-- ads -->
	<div class="mdc-layout-grid__cell--span-12" id="recent-ads" appObserveElement #adList="intersection" (isIntersecting)="isAdListIntersecting = $event">
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12" id="n48">
				<h4 [ngStyle]="{ 'vertical-align': locale.lang === 'en' ? 'middle' : null }">{{ locale.translations['home']['n48'] }}</h4>
				&nbsp;

				<input
					matInput
					[matDatepicker]="datepicker"
					[max]="maxDate"
					[(ngModel)]="selectedDate"
					(dateChange)="onDateSelection($event['value'])"
					hidden
				/>

				<mat-datepicker dir="ltr" touchUi #datepicker></mat-datepicker>

				<button type="button" (click)="datepicker.open()" class="datepicker" [ngStyle]="{ 'vertical-align': locale.lang !== 'en' ? 'middle' : null }">
					<span>{{ selectedDate | date : 'dd/MM/yyyy' }}</span>

					<mat-icon [ngStyle]="{ 'text-align': locale.lang !== 'en' ? 'end' : null }">arrow_drop_down</mat-icon>
				</button>
			</div>

			<ng-container *ngFor="let ad of ads?.['data']; let i = index">
				<!-- AD item -->
				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone box"
					*ngIf="ad['vipPlus'] === '0'"
				>
					<app-ad-item [ad]="ad"></app-ad-item>
				</div>

				<!-- AD item -->
				<div
					class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone"
					*ngIf="ad['vipPlus'] === '1'"
				>
					<app-ad-item-v2 [ad]="ad"></app-ad-item-v2>
				</div>

				<!-- AD banner -->
				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone"
					*ngIf="viewport.type === 'mobile' && (i + 1) % 8 === 0"
				>
					<app-ad-item-banner></app-ad-item-banner>
				</div>
			</ng-container>

			<!-- no results -->
			<div class="mdc-layout-grid__cell--span-12" *ngIf="ads?.['data'] && ads?.['data'].length === 0">
				<div class="mdc-layout-grid__inner center">
					<div class="mdc-layout-grid__cell--span-12">
						<mat-icon class="large">search</mat-icon>
					</div>

					<div class="mdc-layout-grid__cell--span-12">
						<h4 id="n744">{{ locale.translations['n744'] }}</h4>
					</div>
				</div>
			</div>
		</div>

		<div appObserveElement (isIntersecting)="onAdsPaginationIntersect($event, adList._isIntersecting)" #scrollTrigger class="trigger-element"></div>

		<div class="spinner" *ngIf="isMoreAdsLoading">
			<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
		</div>
	</div>

	<div
		class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone my-4 mx-3"
		*ngIf="!loading"
		appObserveElement
		(isIntersecting)="onGoogleAdBannerIntersect($event)"
	>
		<app-google-ad [type]="googleAd.BANNER"></app-google-ad>
	</div>
</div>

<app-inner-footer></app-inner-footer>
